import React, { ReactNode } from 'react';

import { Container } from './styles';

interface FooterProps {
  children: ReactNode;
}

export const Footer: React.FC<FooterProps> = ({children}) => {
  return (
    <Container>
      {children}
    </Container>
  );
}